const smoothScroll = require("smoothscroll");

export default class PaymentNew {
  constructor(args) {
    console.log('payment_new.js loaded');

    // select section
    let payementHeaders = document.querySelectorAll('.payment--main--header');
    for (let i = 0; i < payementHeaders.length; i++) {
      let elem = payementHeaders[i];
      let elemParent = elem.parentElement;
      let id = elem.getAttribute('id');

      if (!elemParent.classList.contains('is-disabled')) {
        elem.onclick = () => {
          for (let i = 0; i < payementHeaders.length; i++) {
            let elem = payementHeaders[i];
            let id = elem.getAttribute('id');
            elem.parentElement.classList.remove('is-selected');
            document.getElementById(id + '_content').classList.remove('is-active');
          }

          elemParent.classList.toggle('is-selected');
          document.getElementById(id + '_content').classList.toggle('is-active');

          setTimeout(function(){ smoothScroll(elem); }, 200);
        }
      }
    }

    // select payment method
    let paymentMethods = document.querySelectorAll('.button_radio');
    for (let i = 0; i < paymentMethods.length; i++) {
      let button = paymentMethods[i];
      let id = button.getAttribute('id');

      button.onchange = () => {
        let content = document.getElementById(id + '_content');
        let siblings = content.parentElement.children;

        for (let i = 0; i < siblings.length; i++) {
          let sibling = siblings[i];
          sibling.classList.remove('is-active');
        }
        content.classList.toggle('is-active');
      }
    }

    // div コンテナーの個数の数だけインスタンスを生成する
    Array.from(Array.from(document.querySelectorAll('.furtherSupport')).keys()).forEach(id => new FurtherSupport(id))
  }
}

/**
 * @class ボタンで支援額を増減する UI のロジック
 */
class FurtherSupport {
  /**
   * コンストラクタ
   * 
   * @param {number} id タブの id、複数のリワードがあるので id を付与しておく必要がある
   */
  constructor(id) {
    /** @var {string} タブの id */
    this.id = String(id)

    /** @var {string} 最後にバリデーターを通過できた値 */
    this.latestValidValue = 0

    this.calculate()

    this.plusAmountElement.addEventListener('input', () => {
      this.validate()
      this.calculate()
    })
  }

  /**
   * 基本価格
   * 
   * @returns {number}
   */
  get basePrice() {
    return Number(document.getElementById(`further_base_amount-${this.id}`).textContent)
  }

  /**
   * 現在の価格のエレメント
   * 
   * @returns {HTMLInputElement}
   */
  get plusAmountElement() {
    return document.getElementById(`further_plus_amount-${this.id}`)
  }

  /**
   * 追加支援額
   * 
   * @returns {number}
   */
  get plusAmount() {
    return Number(this.plusAmountElement.value)
  }

  /**
   * 現在の価格
   * 
   * @returns {number}
   */
  get supportPrice() {
    return Number(document.getElementById(`further_support_price-${this.id}`).textContent)
  }

  /**
   * 現在の価格
   * 
   * @param {number} price 設定する価格
   */
  set supportPrice(price) {
    document.getElementById(`further_support_price-${this.id}`).textContent = String(price)
  }

  /**
   * 入力をバリデート
   * 
   * @returns {boolean} 正しければ true, 不正なら false
   */
  validate() {
    if(this.plusAmountElement.checkValidity())
      this.latestValidValue = this.plusAmountElement.value === '' ? '0' : this.plusAmountElement.value
    else this.plusAmountElement.value = this.latestValidValue
  }

  /**
   * 計算
   * 
   * @returns {void}
   */
  calculate() {
    this.supportPrice = this.basePrice + this.plusAmount
  }
}



// WEBPACK FOOTER //
// ./pages/payment_new.js